<template>
  <UiDialog v-model:open="open">
    <UiDialogContent
      class="max-h-screen-nav kyc-two-popup flex flex-col md:pb-0"
      persistent
      :hide-close-button="preventClose"
      disable-outside-pointer-events
      @interact-outside="(e) => e.preventDefault()"
      @pointer-down-outside="(e) => e.preventDefault()"
      @escape-key-down="(e) => (preventClose ? e.preventDefault() : null)"
    >
      <div class="scrollbar-hide overflow-y-auto" v-auto-animate="autoAnimateFade">
        <PensionKYCTwoForm v-if="page === 'form'" @done="page = 'generate'" />
        <PensionKYCTwoCreateRecommendations v-else @done="afterRecommendationsGenerated" />
      </div>
    </UiDialogContent>
  </UiDialog>
</template>

<script setup lang="ts">
const router = useRouterUtils()
const flowStageManager = usePensionFlowStageManager()

const open = defineModel("open", { default: true })
const kycTwoCookie = useCookie<boolean>("started-kyc-two", { default: () => false })

const page = ref<"form" | "generate">("form")

async function afterRecommendationsGenerated() {
  await flowStageManager.refetchStage()
  closePopup()
}

const preventClose = computed(() => page.value === "generate")

function closePopup() {
  open.value = false

  setTimeout(() => (kycTwoCookie.value = false), 200)

  if ("kyc" in router.route.value.query) {
    router.replace({ query: jsonClean({ ...router.route.value.query, kyc: undefined }) })
  }
}
</script>

<style lang="scss">
.kyc-two-popup {
  @screen min-md {
    max-width: 680px;
  }
}
</style>
